import { render, staticRenderFns } from "./regionCost.vue?vue&type=template&id=95c102ec&scoped=true&"
import script from "./regionCost.vue?vue&type=script&lang=js&"
export * from "./regionCost.vue?vue&type=script&lang=js&"
import style0 from "./regionCost.vue?vue&type=style&index=0&lang=css&"
import style1 from "./regionCost.vue?vue&type=style&index=1&id=95c102ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c102ec",
  null
  
)

export default component.exports